module.exports = __webpack_public_path__ + "img/tamildata-friend-referral.cf57a622.jpg";